import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFirebase } from '../contexts/FirebaseContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
}) => {
  const { currentUser, loading } = useFirebase();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If a role is required, check if the user has it
  if (requiredRole) {
    const userRole = currentUser.displayName; // You might want to store roles in a different way
    if (userRole !== requiredRole) {
      return <Navigate to="/unauthorized" />;
    }
  }

  return <>{children}</>;
}; 